
import {Component, Vue, Prop} from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class componentName extends Vue {
    @Prop({default: () => []}) schoolParams!: Array<string>;
    @Prop({default: () => []}) schoolText!: Array<string>;
    form = {date: []};
    rules = {date: [{type: 'array', required: true, message: '请选择导出时间', trigger: 'change'}]};
    labelCol = {
        xs: {span: 24},
        sm: {span: 5}
    };
    wrapperCol = {
        xs: {span: 24},
        sm: {span: 19}
    };
    exportData() {
        if (Math.abs(moment(this.form.date[0]).diff(moment(this.form.date[1]), 'day')) > 365) {
            this.$message.warning('最大时间范围不能超过365天');
            return;
        }
        (this.$refs['form'] as any).validate((valid: any) => {
            if (valid) {
                const url = this.schoolParams[1]
                    ? `/api/ecode/statistics/usage/excel/class/${this.schoolParams[1]}`
                    : `/api/ecode/statistics/usage/excel/school/${this.schoolParams[0]}`;
                this.fetchFile(url, {
                    to: moment(this.form.date[1]).format('YYYY-MM-DD 24:00:00'),
                    from: moment(this.form.date[0]).format('YYYY-MM-DD 00:00:00')
                });
            }
        });
    }
    fetchFile(url: string, params: any) {
        let paramsArray: string[] = [];
        //拼接参数
        Object.keys(params).forEach(key => paramsArray.push(key + '=' + params[key]));
        if (url.search(/\?/) === -1) {
            url += '?' + paramsArray.join('&');
        } else {
            url += '&' + paramsArray.join('&');
        }
        fetch(url, {
            method: 'GET',
            headers: new Headers({
                Authorization: 'Bearer ' + this.$app.getToken()
            })
        }).then(res => {
            const fileNameEncode = (res.headers.get('content-disposition') as any).split("filename*=UTF-8''")[1];
            // 解码
            const fileName = decodeURIComponent(fileNameEncode);
            res.blob().then(data => {
                const blobUrl = window.URL.createObjectURL(data);
                const a = document.createElement('a');
                a.download = fileName;
                a.href = blobUrl;
                a.click();
                this.$message.success('导出成功');
                this.$emit('close');
            });
        });
    }
    closeModal() {
        this.$emit('close');
    }
}
